import { createContext, useContext, useMemo, useState } from "react";

const SelectedCoupangApiStoreInfosValueContext = createContext();
const SelectedCoupangApiStoreInfosActionsContext = createContext();

export function SelectedCoupangApiStoreInfosContextProvider({ children }) {
    const [coupangApiStoreInfos, setCoupangApiStoreInfos] = useState([]);

    const coupangApiStoreInfosActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setCoupangApiStoreInfos(newValues);
                },
                setValue: setCoupangApiStoreInfos
            }
        },
        []
    )

    return (
        <>
            <SelectedCoupangApiStoreInfosActionsContext.Provider value={{ coupangApiStoreInfos: coupangApiStoreInfosActions }}>
                <SelectedCoupangApiStoreInfosValueContext.Provider value={{ coupangApiStoreInfos }}>
                    {children}
                </SelectedCoupangApiStoreInfosValueContext.Provider>
            </SelectedCoupangApiStoreInfosActionsContext.Provider>
        </>
    );
}

export function useSelectedCoupangApiStoreInfosValueContextHook(props) {
    const value = useContext(SelectedCoupangApiStoreInfosValueContext);

    if (value === undefined) {
        throw new Error('useSelectedCoupangApiStoreInfosValueContextHook should be used within SelectedCoupangApiStoreInfosValueContext');
    }

    return {
        coupangApiStoreInfos: value.coupangApiStoreInfos
    };
}

export function useSelectedCoupangApiStoreInfosActionsContextHook(props) {
    const value = useContext(SelectedCoupangApiStoreInfosActionsContext);

    if (value === undefined) {
        throw new Error('useSelectedCoupangApiStoreInfosActionsContextHook should be used within SelectedCoupangApiStoreInfosActionsContext');
    }

    return {
        coupangApiStoreInfos: {
            onSet: value.coupangApiStoreInfos.onSet,
            setValue: value.coupangApiStoreInfos.setValue
        }
    };
}